import eventsForListening from '../../dom/constants/eventsForListening';
import AbstractController from '../../dom/controllers/abstractController';
import { allKeyCodes, keydownKeyCodes, keyupKeyCodes } from '../constants/usedKeyCodes';
import Vector2d from '../helpers/vector2d';

export default class GameController {
    #model;
    #pressedKeyId;

    keydownHandler;
    keyupHandler;

    #rightButtonId = 'mainCharacterButtonRight';
    #leftButtonId = 'mainCharacterButtonLeft';

    touchstartHandler;
    touchendHandler;

    #mainCharacterKeyboardController;
    #mainCharacterButtonsController;

    constructor(model) {
        this.#model = model;

        this.keydownHandler = this.toKeydown.bind(this);
        this.keyupHandler = this.toKeyup.bind(this);
        this.touchstartHandler = this.toTouchstart.bind(this);
        this.touchendHandler = this.toTouchend.bind(this);

        this.createMainCharacterKeyboardController();
        this.createMainCharacterButtonsController();
    }

    createMainCharacterButtonsController() {
        const arrowLeft = document.getElementById('mainCharacterButtonLeft');
        const arrowRight = document.getElementById('mainCharacterButtonRight');

        this.#mainCharacterButtonsController = new AbstractController([arrowLeft, arrowRight], [
            {
                events: [eventsForListening.TOUCHSTART],
                functionForEvents: this.touchstartHandler
            },
            {
                events: [eventsForListening.TOUCHEND],
                functionForEvents: this.touchendHandler
            }
        ]);
    }

    createMainCharacterKeyboardController() {
        this.#mainCharacterKeyboardController = new AbstractController([document], [
            {
                events: [eventsForListening.KEYDOWN],
                functionForEvents: this.keydownHandler
            },
            {
                events: [eventsForListening.KEYUP],
                functionForEvents: this.keyupHandler
            }
        ]);
    }

    startListeners() {
        this.#mainCharacterKeyboardController.startListeners();
        this.#mainCharacterButtonsController.startListeners();
    }

    stopListeners() {
        this.toKeyup({ key: this.#pressedKeyId });
        this.#mainCharacterKeyboardController.stopListeners();
        this.#mainCharacterButtonsController.stopListeners();
    }

    toTouchstart(event) {
        event.preventDefault();
        event.stopPropagation();

        const { id } = event.currentTarget;

        if (!id) return;

        this.#pressedKeyId = id;

        switch (id) {
            case this.#rightButtonId:
                this.toMoveCharacter(1);

                break;
            case this.#leftButtonId:
                this.toMoveCharacter(-1);

                break;
            default:
        }
    }

    toTouchend(event) {
        event.preventDefault();
        event.stopPropagation();

        if (!event.target?.closest(`#${this.#pressedKeyId}`)) return;

        this.stopMovingCharacter();
    }

    toKeydown(event) {
        if (!keydownKeyCodes[event.key]) return;

        if (keyupKeyCodes[event.key]) this.#pressedKeyId = event.key;

        switch (event.key) {
            case allKeyCodes.ArrowRight:
            case allKeyCodes.d:
                this.toMoveCharacter(1);

                break;
            case allKeyCodes.ArrowLeft:
            case allKeyCodes.a:
                this.toMoveCharacter(-1);

                break;
            default:
        }
    }

    toKeyup(event) {
        if (!keyupKeyCodes[event.key] || !(event.key === this.#pressedKeyId)) return;

        switch (event.key) {
            case allKeyCodes.ArrowRight:
            case allKeyCodes.ArrowLeft:
            case allKeyCodes.a:
            case allKeyCodes.d:
                this.stopMovingCharacter();

                break;
            default:
        }
    }

    stopMovingCharacter() {
        this.#model.stopMovingCharacter();
    }

    toMoveCharacter(xDirection) {
        const movementVector = new Vector2d(xDirection, 0).unitVector;

        this.#model.startMovingCharacter(movementVector);
    }
}
